<template>
  <div>
    <div v-if="!isLoading">
      <div class="revocation_defense" v-if="!isLoading && isGetRewords">
        <p class="rd-messsage-box">
          <span class="rd-messsage01">감사합니다.</span>
          <span class="rd-messsage02">코인이 지급되었습니다.</span>
          <GiftImage/>
        </p>
        <a href="#" class="rd-confirm" @click.prevent="isOk('y')">확인</a>
        <p class="rd-exclamation-box">
          <span class="dot-text">다음 결제일에 이용권이 정상결제됩니다.</span>
          <span class="dot-text">코인은 [MY > 코인내역]에서 확인하실 수 있습니다.</span>
          <span class="dot-text">보너스 코인을 사용한 경우 전자상거래법 등 관련 법률에 따라 해지 신청이 제한될 수 있습니다.</span>
          <span class="dot-text">웨이브 코인: 방송VOD/영화 단건 구매 시 사용 가능</span>
        </p>
      </div>
      <div class="revocation_defense" v-if="!isLoading && !isGetRewords">
        <p class="rd-messsage-box">
          <AttentionMark />
          <span class="rd-messsage01">해지 취소 &amp; 선물 받기 실패</span>
          <span class="rd-messsage02" v-html="resultMessage"></span>
        </p>
        <a href="#" class="rd-confirm" @click.prevent="isOk('n')">확인</a>
      </div>
    </div>
    <LoadingWithProps :show-loading="isLoading" />
  </div>
</template>
<script>
import { MyPooqService } from '@/common/api/api.service'
import { get } from 'lodash'
import { mapMutations } from 'vuex'
import GiftImage from '@/assets/svg/common/reward_popup/gift-image.svg'
import AttentionMark from '@/assets/svg/common/reward_popup/AttentionMark.svg'
import LoadingWithProps from '@/components/LoadingWithProps'
import utils from '@/common/util/utils'
import { PATH_NAME_COIN, PATH_NAME_HOME } from '@/common/router.const'
import { DEVICE_TYPE_ANDROID } from '@/common/devicetype.const'
export default {
  name: 'RevocationDefense',
  components: {
    LoadingWithProps,
    GiftImage,
    AttentionMark
  },
  data () {
    return {
      isGetRewords: false,
      isLoading: false,
      resultMessage: '참여 대상자가 아니시네요.',
      device: utils.cookies.getDevice()
    }
  },
  methods: {
    ...mapMutations(['setBeforePathOpenMyPooq']),
    isOk (status) {
      if (this.device === DEVICE_TYPE_ANDROID) {
        if (status === 'y') {
          location.href = 'captvpooq://mypooq/coin?iswebclose=y'
        } else {
          window.Android.ClosePopup('ClosePopup')
        }
      } else {
        if (status === 'y') {
          this.setBeforePathOpenMyPooq('/')
          this.$router.replace({ name: PATH_NAME_COIN })
        } else {
          this.$router.replace({ name: PATH_NAME_HOME })
        }
      }
    }
  },
  async created () {
    const SYSTEM_ERROR_MESSAGE = '정상 처리되지 않았습니다.\n나중에 다시 시도해주세요.'
    const ALREADY_RECEIVE_COIN = '이미 참여하셨어요.\n본 혜택은 1회만 제공받을 수 있어요.'
    const DEFAULT_ERROR_MESSAGE = '참여 대상자가 아니시네요.'
    this.resultMessage = DEFAULT_ERROR_MESSAGE
    // if (this.isLoading) return
    this.isLoading = true
    const response = await MyPooqService.purchaseProduct({
      startdate: '',
      enddate: '',
      producttype: 'pass',
      autopayment: 'n',
      offset: 0,
      limit: 10,
      orderby: 'new'
    })
    if (response.status === 200) {
      const targetVoucher = voucher => voucher.autopayment === 'true' && voucher.autopaymentstatus === 'n' && voucher.packagemasterid !== '6'
      const unsubscribeVoucherList = get(response, ['data', 'list'], []).filter(targetVoucher)
      const hasOneUnSubscribeVoucher = unsubscribeVoucherList.length === 1
      const serviceId = get(unsubscribeVoucherList, ['0', 'userserviceid'], '')
      // 이벤트 대상자일때
      if (hasOneUnSubscribeVoucher) {
        const receiveCoin = await MyPooqService.myPurchasePassEvent({ eventType: 'continuepass' }, (err) => {
          if (err.response && err.response.status === 550) {
            let message = err.response.data.resultmessage ? err.response.data.resultmessage
              : '서버에서 알 수 없는 오류가 발생했습니다.'
            message = message.indexOf('이미') > -1 ? ALREADY_RECEIVE_COIN : SYSTEM_ERROR_MESSAGE
            this.resultMessage = message
          }
        })
        if (receiveCoin && receiveCoin.status === 200) {
          let cancelResult = await MyPooqService.passPromotionCancel(
            { productType: 'pass', keyId: serviceId, status: 1 },
            (err) => { // catchFn - 이용권 해지 취소 에러 케이스 1. 서버에서 에러를 발생 시켰을때, 에러 메세지를 출력하고 취소 화면을 보여주고나 화면을 메인으로 리다이렉트 시킨다. (결정 필요)
              if (err.response && err.response.status === 550) {
                this.resultMessage = SYSTEM_ERROR_MESSAGE
              }
            })
          if (cancelResult.status === 200) {
            this.isGetRewords = true
            this.isLoading = false
          }
        } else {
          MyPooqService.passPromotionCancel({ productType: 'pass', keyId: serviceId, status: 0 }).then((response) => {
            this.isGetRewords = false
            this.isLoading = false
          })
        }
      } else {
        this.resultMessage = DEFAULT_ERROR_MESSAGE
        this.isGetRewords = false
        this.isLoading = false
      }
    } else {
      this.isGetRewords = false
      this.isLoading = false
      this.resultMessage = SYSTEM_ERROR_MESSAGE
    }
  }
}
</script>

<style scoped>
  .revocation_defense{
    z-index: 10;
    margin: 50px 10px;
    padding: 120px 0;
    background: #1b1b1b;
    overflow: hidden
  }

  /* 상단 메세지 */
  .rd-messsage-box{
    display: block;
    text-align: center
  }
  .rd-messsage01{
    display: block;
    font-size: 20px;
    line-height: 29px;
    color: #fff;
    font-weight: 700;
  }
  .rd-messsage02{
    display: block;
    margin: 10px 0 20px;
    font-size: 14px;
    line-height: 20px;
    color: #a5a5a5;
  }

  /* 확인 버튼 */
  .rd-confirm{
    display: block;
    margin: 50px auto 20px;
    padding: 14px 10px;
    text-align: center;
    font-weight: 700;
    font-size: 16px;
    line-height: 18px;
    color: #fff;
    background-color: #f66ca3;
    border-radius: 30px
  }

  /* 주의사항 */
  .rd-exclamation-box{
    display: block;
  }
  .dot-text {
    display: block;
    vertical-align: top;
    margin-bottom: 4px;
    padding-left: 5px;
    font-size: 12px;
    line-height: 18px;
    color: #717171;
    text-indent: -5px;
  }
  .dot-text:before {
    display: inline-block;
    vertical-align: top;
    content: "";
    width: 2px;
    height: 2px;
    margin-top: 8px;
    margin-right: 5px;
    border-radius: 1px;
    background-color: #717171;
  }
</style>
